var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "login-change" } }, [
    _vm.isLoggedIn
      ? _c("div", { staticClass: "dropdown" }, [
          _c("input", {
            attrs: { type: "hidden", value: "true", id: "is-logged-in" }
          }),
          _vm._v(" "),
          _c("div", [
            _c(
              "a",
              {
                staticClass: "dropdown-toggle",
                attrs: {
                  href: "#",
                  id: "accountMenuList",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false"
                }
              },
              [
                _c("div", { staticClass: "login-change__user-icon" }, [
                  _c(
                    "svg",
                    {
                      staticStyle: {
                        "enable-background": "new 0 0 513.323 513.323"
                      },
                      attrs: {
                        version: "1.1",
                        id: "Capa_1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        x: "0px",
                        y: "0px",
                        viewBox: "0 0 513.323 513.323",
                        "xml:space": "preserve"
                      }
                    },
                    [
                      _c("g", [
                        _c("g", [
                          _c("path", {
                            attrs: {
                              d:
                                "M256.661,257.323c-135.275,0-245.333,110.059-245.333,245.333c0,5.888,4.779,10.667,10.667,10.667\n                                    s10.667-4.779,10.667-10.667c0-123.52,100.48-224,224-224s224,100.48,224,224c0,5.888,4.779,10.667,10.667,10.667\n                                    c5.888,0,10.667-4.779,10.667-10.667C501.995,367.36,391.936,257.323,256.661,257.323z"
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("g", [
                        _c("g", [
                          _c("path", {
                            attrs: {
                              d:
                                "M256.661,0c-64.683,0-117.333,52.629-117.333,117.333s52.651,117.333,117.333,117.333s117.333-52.629,117.333-117.333\n                                    S321.344,0,256.661,0z M256.661,213.333c-52.928,0-96-43.072-96-96s43.072-96,96-96c52.928,0,96,43.072,96,96\n                                    S309.589,213.333,256.661,213.333z"
                            }
                          })
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Konto")])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "account-menu dropdown-menu dropdown-menu-right small"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "list-group",
                    attrs: { "aria-labelledby": "accountMenuList" }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "list-group-item small",
                        attrs: { href: _vm.$ceres.urls.myAccount }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.loginMyAccount")
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [{ name: "logout", rawName: "v-logout" }],
                        staticClass: "list-group-item small",
                        attrs: { href: "#" }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$translate("Ceres::Template.loginLogout"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "list-group-item small",
                        attrs: { href: _vm.$ceres.urls.wishList }
                      },
                      [_vm._v("Merkliste")]
                    )
                  ]
                )
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn
      ? _c("div", [
          _c("input", {
            attrs: { type: "hidden", value: "false", id: "is-logged-in" }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              attrs: {
                "data-toggle": "modal",
                href: _vm.isLogin ? "javascript:void(0)" : "#login",
                "data-toggle": _vm.isLogin ? false : "modal",
                "aria-label": _vm.$translate("Ceres::Template.login")
              },
              on: {
                click: function($event) {
                  _vm.createLoginModal()
                  _vm.unmarkInputFields()
                }
              }
            },
            [
              _c("div", { staticClass: "login-change__user-icon" }, [
                _c(
                  "svg",
                  {
                    staticStyle: {
                      "enable-background": "new 0 0 513.323 513.323"
                    },
                    attrs: {
                      version: "1.1",
                      id: "Capa_1",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      x: "0px",
                      y: "0px",
                      viewBox: "0 0 513.323 513.323",
                      "xml:space": "preserve"
                    }
                  },
                  [
                    _c("g", [
                      _c("g", [
                        _c("path", {
                          attrs: {
                            d:
                              "M256.661,257.323c-135.275,0-245.333,110.059-245.333,245.333c0,5.888,4.779,10.667,10.667,10.667\n                      s10.667-4.779,10.667-10.667c0-123.52,100.48-224,224-224s224,100.48,224,224c0,5.888,4.779,10.667,10.667,10.667\n                      c5.888,0,10.667-4.779,10.667-10.667C501.995,367.36,391.936,257.323,256.661,257.323z"
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("g", [
                        _c("path", {
                          attrs: {
                            d:
                              "M256.661,0c-64.683,0-117.333,52.629-117.333,117.333s52.651,117.333,117.333,117.333s117.333-52.629,117.333-117.333\n                      S321.344,0,256.661,0z M256.661,213.333c-52.928,0-96-43.072-96-96s43.072-96,96-96c52.928,0,96,43.072,96,96\n                      S309.589,213.333,256.661,213.333z"
                          }
                        })
                      ])
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", [_vm._v("Login")])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }